import { Box, IconButton, useMediaQuery } from "@mui/material";
import Grid from "@mui/material/Grid2";
import moment from "moment";
import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import Loading from "../../components/Loading";
import Bed from "../../assets/bed.svg";
import Bath from "../../assets/bath.svg";
import Sqft from "../../assets/sqft.svg";
import { useDispatch, useSelector } from "react-redux";
import { completeAuction } from "../../redux/slice/accountSlice";
import { AppDispatch } from "../../redux/store";
import Wonreceipt from "../../assets/wonreceipt.svg";
import { textColor } from "../../utils/commonstyle";

const index = () => {
  const isMdOrLarger = useMediaQuery("(min-width:1000px)");
  const navigate = useNavigate();
  const isMobile: any = useOutletContext();
  const { loginInvestorId, loginUserDetails } = useSelector((state: any) => state.user);
  const [loading, setLoading] = useState(false);
  const [properties, setProperties] = useState<any[]>([]);
  const dispatch = useDispatch<AppDispatch>();
  const [investorIdCheck, setInvestoprIdCheck] = useState<any>('')
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  // On mount: load from sessionStorage if available, else fetch
  useEffect(() => {
    handleInvestorId();
    // const cached = sessionStorage.getItem('completedAuctions');
    // if (cached) {
    //   setProperties(JSON.parse(cached));
    //   setLoading(false);
    // } else
    if (loginInvestorId) {
      setLoading(true);
      handleGetdata();
    }
    // eslint-disable-next-line
  }, [loginInvestorId]);

  // Save data to sessionStorage whenever properties change
  useEffect(() => {
    if (properties && properties.length > 0) {
      sessionStorage.setItem('completedAuctions', JSON.stringify(properties));
    }
  }, [properties]);

  // Restore scroll position after properties are rendered
  useEffect(() => {
    const savedScroll = sessionStorage.getItem('completedAuctionsScroll');
    if (!savedScroll) return;

    let tries = 0;
    const maxTries = 20; // Try for up to 1 second (20 * 50ms)
    const desiredScroll = parseInt(savedScroll, 10);

    function tryRestoreScroll() {
      const node = scrollContainerRef.current;
      if (node) {
        // Only restore if the content is tall enough
        if (node.scrollHeight - node.clientHeight >= desiredScroll || tries > maxTries) {
          node.scrollTop = desiredScroll;
        } else {
          tries++;
          setTimeout(tryRestoreScroll, 50);
        }
      }
    }

    tryRestoreScroll();
  }, [properties]);

  // Save scroll position on scroll
  useEffect(() => {
    const handleScroll = () => {
      if (scrollContainerRef.current) {
        sessionStorage.setItem('completedAuctionsScroll', String(scrollContainerRef.current.scrollTop));
      }
    };
    const node = scrollContainerRef.current;
    if (node) node.addEventListener('scroll', handleScroll);
    return () => {
      if (node) node.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleGetdata = async () => {
    const response = await dispatch(completeAuction(loginInvestorId)).unwrap();
    setProperties(response.data);
    setLoading(false);
  };

  const handleInvestorId = () => {
    // Check if BusinessAccounts and PurchaseProfile exist and have data
    if (loginUserDetails?.BusinessAccounts && (loginUserDetails?.BusinessAccounts?.length > 0 || loginUserDetails?.PurchaseProfile?.length > 0)) {
      const businessInvestorIds = loginUserDetails?.BusinessAccounts.map((ele: any) => ele.InvestorId);
      // Check if PurchaseProfile exists and has data
      const purchaseProfileInvestorIds = loginUserDetails?.PurchaseProfile?.map((ele: any) => ele.InvestorId) || [];
      // Combine both arrays (BusinessAccounts and PurchaseProfile)
      setInvestoprIdCheck([loginInvestorId, ...businessInvestorIds, ...purchaseProfileInvestorIds]);
    } else {
      // If BusinessAccounts is empty or doesn't exist, set only the loginInvestorId
      setInvestoprIdCheck([loginInvestorId]);
    }
  };

  const openPDFModal = (url: string, name: string) => {
    const fileExtension = name.split(".").pop()?.toLowerCase();
    if (!fileExtension) {
      console.error("File extension is missing");
      return;
    }

    // Handle PDF files
    if (fileExtension === "pdf") {
      // Open the URL in a new tab
      const newTab = window.open(url, "_blank");
      if (newTab) {
        newTab.focus(); // Focus the new tab (optional)
      }
    }
    // Handle image files (optional for future use)
    else if (["jpg", "jpeg", "png", "gif"].includes(fileExtension)) {
      const newTab = window.open(url, "_blank");
      if (newTab) {
        newTab.focus(); // Focus the new tab (optional)
      }
    } else {
      console.error("Unsupported file type");
      return;
    }
  };

  function formatToDollar(amount: any) {
    return new Intl.NumberFormat("en-US", {
      style: "decimal",
      minimumFractionDigits: 0, // No decimal places
      maximumFractionDigits: 0,
    }).format(amount);
  }

  const handleViewDetails = (property: any) => {
    const remoteflag = true;
    navigate(`/auctionPage/${property.auctionVendorPropId}`, {
      state: { remoteflag },
    });
  };

  return (
    <div className=" bg-white md:p-4 p-0" ref={scrollContainerRef} style={{ overflowY: 'auto', height: '88vh' }}>
      <div className=" flex justify-between mb-4">
        <div className="text-lg font-semibold ml-2 sm:mt-6 md:mt-0 xs:mt-0" role="heading" >
          Showing {properties?.length} Auction Properties
        </div>
      </div>
      <div className="space-y-4">
        <div>
          {loading ? (
            <Loading height={"600px"} />
          ) : properties && properties?.length > 0 ? (
            properties?.map((property: any, index) => {

              return (
                <Grid
                  key={index}
                  container
                  className="bg-white p-2 flex w-full mb-3 "
                  sx={{ width: "100%" }}
                  spacing={{ xs: 1, sm: 2 }}
                  style={{ boxShadow: "0px 0px 3px 2px rgba(0,0,0,.1)" }}
                >
                  <Grid

                    size={{ xs: 4, sm: 3, md: 1.7 }}
                    style={{
                      height: "auto", // Adjust this if you need a fixed height
                      position: "relative", // Add this to position the heart icon inside the image container
                    }}
                  >
                    <div
                      className={isMdOrLarger ? "w-[100%]" : ""}
                      style={{
                        position: "relative",
                        padding: "5px",
                        // width: 200,
                        height: 140,
                      }}
                    >
                      <img
                        src={property?.imageUrl}
                        alt="Property"
                        className=" w-full h-full object-cover rounded-none" // Use object-cover to maintain aspect ratio
                      />
                      <IconButton
                        aria-label="Toggle favorite property"
                        style={{
                          position: "absolute",
                          top: "10px", // Adjust to control distance from the top
                          left: "10px", // Adjust to control distance from the left
                          zIndex: 1, // Ensure the icon stays on top of the image
                          cursor: "pointer",
                        }}
                      >
                        {property?.auctionVendorPropId ? (
                          <svg
                            stroke="#ffffff"
                            fill="#ffffff"
                            stroke-width="0"
                            viewBox="0 0 1024 1024"
                            height="1em"
                            width="1em"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M923 283.6a260.04 260.04 0 0 0-56.9-82.8 264.4 264.4 0 0 0-84-55.5A265.34 265.34 0 0 0 679.7 125c-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5a258.44 258.44 0 0 0-56.9 82.8c-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3.1-35.3-7-69.6-20.9-101.9zM512 814.8S156 586.7 156 385.5C156 283.6 240.3 201 344.3 201c73.1 0 136.5 40.8 167.7 100.4C543.2 241.8 606.6 201 679.7 201c104 0 188.3 82.6 188.3 184.5 0 201.2-356 429.3-356 429.3z"></path>
                          </svg>
                        ) : (
                          <svg
                            stroke="#ffffff"
                            fill="#ffffff"
                            stroke-width="0"
                            viewBox="0 0 1024 1024"
                            height="1em"
                            width="1em"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="M923 283.6a260.04 260.04 0 0 0-56.9-82.8 264.4 264.4 0 0 0-84-55.5A265.34 265.34 0 0 0 679.7 125c-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5a258.44 258.44 0 0 0-56.9 82.8c-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3.1-35.3-7-69.6-20.9-101.9z"></path>
                          </svg>
                        )}
                      </IconButton>
                    </div>
                  </Grid>

                  <Grid size={{ xs: 6.6, sm: "auto" }}>
                    <p className="text-lg sm:text-xl">
                      <span className="text-[16px] sm:text-[18px] md:text-[20px]  font-semibold leading-[30px]">

                        $
                        {property?.openingBid === null || property?.openingBid === 0 || property?.openingBid === 0.00
                          ? (property?.reserveValue > 0 ? formatToDollar(property?.reserveValue) : 0)
                          : formatToDollar(property?.openingBid)}
                      </span>
                      <span className="text-[14px] mx-2 font-normal leading-[21px]">
                        Est. Opening Bid
                      </span>
                    </p>
                    <p className="mt-1 sm:mt-2  sm:font-light text-[10px] sm:text-base">
                      Foreclosure Trustee - Remote bid enabled
                    </p>
                    <p className="mt-1 sm:mt-2 text-sm sm:text-base font-medium text-gray-700">
                      {property?.address1} {property?.city} ,{property?.state}{" "}
                      {property?.zipCode}
                    </p>
                    {!isMobile && (
                      <>
                        <div className="flex items-center space-x-2 mt-2">
                          {property?.beds ? (
                            <div className="flex items-center space-x-1">
                              <img src={Bed} alt="bed" />
                              <span>{property?.beds} Beds</span>
                            </div>
                          ) : (
                            ""
                          )}
                          {property?.fullBaths ? (
                            <div className="flex items-center space-x-1">
                              <img src={Bath} alt="bed" />
                              <span>
                                {property?.fullBaths
                                  ? property?.fullBaths
                                  : "-"}
                                Baths
                              </span>
                            </div>
                          ) : (
                            ""
                          )}
                          {property?.sqFt ? (
                            <div className="flex items-center space-x-1">
                              <img src={Sqft} alt="bed" />
                              <span>
                                {property?.sqFt
                                  ? formatToDollar(property?.sqFt)
                                  : "-"}
                                Sq. Ft.
                              </span>
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="w-3/5 mt-2">
                          {moment
                            .parseZone(property?.currentSaleDate)
                            .format("MMM D YYYY")}{" "}
                          {property?.currentSaleTime}
                          {/* {moment
                            .parseZone(property?.SRPSaleDateTime)
                            .format("MMM D, hh:mm A")} */}
                        </div>
                      </>
                    )}
                  </Grid>
                  <Grid
                    size={{ xs: 12, sm: "auto" }}
                    display={"flex"}
                    ml={{ sm: "auto" }}
                    // justifyContent={"space-between"}
                    alignItems={{ sm: "flex-end" }}
                    rowGap={{ xs: 1 }}
                    flexDirection={"column"}
                  >
                    <Box
                      sx={{
                        border:
                          investorIdCheck?.includes(property.winnerInvestorId)
                            ? "1px solid #28A745"
                            : "1px solid grey",
                        color:
                          investorIdCheck?.includes(property.winnerInvestorId)
                            ? "#28A745"
                            : "initial",
                        p: 1,
                        fontSize: "16px",
                        width: "auto",
                      }}
                    >
                      {property?.soldStatus}
                    </Box>
                    {property.rosName ? (
                      <Box color={textColor.primaryColor}>
                        {investorIdCheck?.includes(property.winnerInvestorId) && (
                          <Box
                            onClick={() =>
                              openPDFModal(
                                property?.receiptOfSaleUrl,
                                property.rosName
                              )
                            }
                            mb={{ md: 3, xs: 0 }}
                            sx={{ cursor: "pointer" }}
                            display={"flex"}
                            alignItems={"center"}
                          >
                            <img
                              src={Wonreceipt}
                              alt="won-receipt"
                              width={20}
                              height={18}
                              style={{ marginRight: 4 }}
                            />{" "}
                            <span style={{ textDecoration: "underline" }}>
                              {property.rosName}
                            </span>
                          </Box>
                        )}
                      </Box>
                    ) : (
                      <Box ></Box>
                    )}

                    {isMobile && (
                      <div className="flex items-center space-x-2 mt-2">
                        <div className="flex items-center space-x-1">
                          <img src={Bed} alt="bed" />
                          <span>{property?.beds} Beds</span>
                        </div>
                        <div className="flex items-center space-x-1">
                          <img src={Bath} alt="bed" />
                          <span>{property?.fullBaths} Baths</span>
                        </div>
                        <div className="flex items-center space-x-1">
                          <img src={Sqft} alt="bed" />
                          <span>{formatToDollar(property?.sqFt)} Sq. Ft.</span>
                        </div>
                      </div>
                    )}
                    <div className="flex justify-between items-center">
                      {isMobile && (
                        <div>
                          {moment
                            .parseZone(property?.boardingDt)
                            .format("MMM D, hh:mm A")}
                        </div>
                      )}
                      {investorIdCheck?.includes(property.winnerInvestorId) && (
                        <button
                          className=" text-white rounded-lg bg-[#FF5C39] px-[16px] py-[10px]"
                          onClick={() => handleViewDetails(property)}
                          aria-label="View details of the property"
                        >
                          View Details
                        </button>
                      )}
                    </div>
                  </Grid>
                </Grid>
              );
            })
          ) : (
            <Box
              display={"flex"}
              textAlign={"center"}
              lineHeight={2}
              justifyContent={"center"}
              minHeight={"600px"}
              alignItems={"center"}
            >
              No completed auctions available.
              <br /> All completed auctions where you participated with a live
              or proxy bid will be displayed here.
            </Box>
          )}
        </div>
      </div>
    </div>
  );
};

export default index;
